<template>
  <div class="inscription-flow-info container">
    <div v-html="$appSettings.ContentStringIndex">
      {{ $appSettings.ContentString }}
    </div>

    <div class="flex buttons flex-centered">
      <a class="btn primary-color have-cps" :href="$appSettings.CPSURL">{{
        $texts.cpsUrlButton
      }}</a>
      <router-link
        v-if="!cardLessRegistrationButtonEnabled"
        class="btn secondary-color have-cps"
        :to="{
          name: 'inscription-flow-info',
        }"
        >{{ $texts.noCpsUrlButton }}</router-link
      >

      <a
        class="btn secondary-color have-cps"
        v-if="cardLessAlternativeRegistrationEnabled"
        :href="cardLessAlternativeRegistrationUrl"
      >
        {{ $texts.noCpsUrlButton }}
      </a>
    </div>

    <footer-panel-vuetify
      :silentRefreshUrl="$appSettings.SilentRefreshUrl"
    ></footer-panel-vuetify>
  </div>
</template>

<script>
// import Loader from './components/Loader.vue'
import FooterPanelVuetify from "@/Commons/components/FooterPanelVuetify.vue";
import { UserSessionService } from "@/InscriptionFlow/services/UserSessionService";
import Vue from "vue";

export default Vue.extend({
  name: "index",

  components: { FooterPanelVuetify },

  data() {
    return {
      flowName: String,
      formData: null,
      authenticationLevel: null,
      loading: false,
      cardLessRegistrationButtonEnabled: false,
      cardLessAlternativeRegistrationEnabled: false,
      cardLessAlternativeRegistrationUrl: "",
    };
  },

  computed: {},

  methods: {
    getName() {
      return window["inscriptionFlowSettings"].Name;
    },
    getAuthenticationLevel() {
      this.loading = true;
      UserSessionService.getUserAuthenticationLevel()
        .then((result) => {
          this.authenticationLevel = result.authenticationLevel;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.flowName = this.getName();
    this.cardLessRegistrationButtonEnabled =
      window["inscriptionFlowSettings"].CardLessRegistrationButtonEnabled;
    this.cardLessAlternativeRegistrationEnabled =
      window["inscriptionFlowSettings"].CardLessAlternativeRegistrationEnabled;
    this.cardLessAlternativeRegistrationUrl =
      window["inscriptionFlowSettings"].CardLessAlternativeRegistrationUrl;
  },
  watch: {
    authenticationLevel: {
      immediate: true,
      handler(val) {
        this.getAuthenticationLevel();
        if (val >= 10) {
          this.$router.push({
            name: "form-cps-register",
          });
        } else if (val >= 2) {
          this.$router.push({
            name: "inscription-flow-register",
          });
        }
      },
    },
  },
});
</script>

<style scoped></style>
